export default (timestamp) => {
  const date = new Date(timestamp * 1000);
  const html = document.documentElement;
  const timeZone = html.getAttribute('data-timezone') || 'UTC';

  return date.toLocaleString(html.lang, { timeZone, timeZoneName: 'short' });
};
